import {Component, Input, OnInit} from '@angular/core';
import {INewsPost} from '@api/models/news/news';
import {NewsHttpService} from '@api/http/news/news-http.service';
import {IUTMParameters} from '@utils/services/url/url.service';

const UTM_PARAM_SETTINGS: Readonly<IUTMParameters> = {
  utm_source: 'fan.at',
  utm_medium: 'in-news-text',
  utm_campaign: 'recirculation'
}

@Component({
  selector: 'app-news-related-articles',
  templateUrl: './news-related-articles.component.html',
  styleUrls: ['./news-related-articles.component.scss']
})
export class NewsRelatedArticlesComponent implements OnInit {

  @Input() count = 2;
  @Input() relatedArticleIds: string[] = [];
  @Input() relationBaseId: string;

  news: INewsPost[];
  constructor(
    private newsService: NewsHttpService,
  ) { }

  async ngOnInit(): Promise<void> {
    if (this.relatedArticleIds?.length > 0) {
      this.news = await Promise.all(this.relatedArticleIds.map(newsId => this.newsService.getNews(newsId)));
    } else {
      const response = await this.newsService.getRelatedNews(this.relationBaseId, this.count);
      if (response.success) {
        this.news = response.data;
      }
    }
  }

  public positionalUTMParams(newsPosition: number): IUTMParameters {
    const params = Object.assign({}, UTM_PARAM_SETTINGS) as IUTMParameters;
    params.utm_content = `position-${newsPosition}`;

    return params;
  }
}
